import { Link, useLocation } from "react-router-dom";
import { Users } from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

import { NavMain } from "./nav-main";
import { NavUser } from "./nav-user";

interface AppSidebarProps extends React.ComponentProps<typeof Sidebar> {
  onLogout: () => void;
  userEmail?: string;
}

export function AppSidebar({ onLogout, userEmail, ...props }: AppSidebarProps) {
  const { pathname } = useLocation();
  const user = {
    name:
      userEmail
        ?.split("@")[0]
        ?.replace(/[._]/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase()) || "Admin",
    email: userEmail || "admin@hashtaginc.co.in",
    avatar: "",
  };

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild>
              <Link to="/">
                <img
                  src="/assets/icons/hashtag_logo.svg"
                  alt="Hashtag Inc."
                  className="size-4 shrink-0 object-contain"
                />
                <span className="font-semibold text-base">LeadFlow</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip="Team"
              isActive={pathname === "/team"}
            >
              <Link to="/team">
                <Users />
                <span>Team</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
        <NavUser user={user} onLogout={onLogout} />
      </SidebarFooter>
    </Sidebar>
  );
}
